import { memo } from 'react';
// @mui
import { 
  Stack,
  Typography,
} from '@mui/material';
// components
import Avatar from '../../components/Avatar';

// ----------------------------------------------------------------------

function CrewAvatar({ hashId, nickname, width=24, height=24, nameVariant="body1", sx={} }) {
  if (!hashId) return null;
  return (
    <Stack direction="row" spacing={1} sx={{ overflow: 'hidden', ...sx }}>
      <Avatar
        src={`https://spacey-dio-public.s3.ap-northeast-2.amazonaws.com/crewji/crewji_${hashId}.png`}
        alt={nickname}
        color={'default'}
        sx={{
          width: width,
          height: height,
        }}
      />
      <Typography variant={nameVariant} sx={{ textOverflow: 'ellipsis' }} noWrap>
        <b>{nickname}</b> 크루
      </Typography>
    </Stack>
  )
}

export default memo(CrewAvatar);
